module.exports = __webpack_public_path__ + "img/23.bc5b29e3.png";